import React, { Component } from 'react';

import ResellerLogo from '../../components/header/ResellerLogo';
import ResellerCSS from '../../components/header/ResellerCSS';

class PersonHeader extends Component {
  render() {
    return (
      <header className="no-print">
        <ResellerLogo url={window.location.pathname} />

        <div className="top-header">
          <nav className="left-nav">
          </nav>

          <nav className="right-nav">
          </nav>
        </div>

        <div className="bottom-header">
          <div className="dr-header-text">
            Digital Reception
          </div>
        </div>

        <ResellerCSS /> {/* We don't currently set resellers for people but it keeps the page in sync with the ResellerLogo */}
      </header>
    )
  }
}

export default PersonHeader;
